<template>
  <div :class="['foto-container', { 'bg': entidade.instrutor }]">
    <div class="perfil">
      <div class="img-container">
        <img
          class="card-img-top"
          :src="'data:image/jpeg;base64, ' + entidade.perfil"
          alt="Falha ao carregar imagem"
        />
        <div class="nome-overlay">{{ entidade.instrutor || entidade.aluno }}</div>
      </div>

      <div class="actions">
        <Button
          type="button"
          text="Fotos"
          color="secondary"
          @handle:click="modalPhotos(entidade)"
          :disabled="loading"
        />
        <template v-if="tab !== 'conferidos' && entidade.aluno && entidade.fotos.length >= 5">
          <Button
            type="button"
            text="Conferir"
            color="success"
            @handle:click="checkAluno(entidade, false)"
            :disabled="loading"
          />
          <Button
            type="button"
            text="Irregularidade"
            color="danger"
            :fill="false"
            @handle:click="checkAluno(entidade, true)"
            :disabled="loading"
          />
        </template>
        <Button
          type="button"
          text="Reportar"
          color="danger"
          @handle:click="modalReport(entidade, entidade.instrutor ? 'INSTRUTOR' : 'ALUNO')"
          :disabled="loading"
        />

        <div class="presenca" v-if="entidade.presencas.find(element => element.tipo == 0)">
          <BadgeCircle color="green" />

          <span>Presença registrada</span>
        </div>

        <div class="presenca" v-else>
          <BadgeCircle color="red" />

          <span>Sem registro de entrada</span>
        </div>
      </div>
    </div>

    <div class="photos">
      <div
        class="photo"
        v-for="arrayFotos in entidade.fotos.slice(0, 5)"
        :key="arrayFotos.id_foto_teorica"
      >
        <img
          :src="'data:image/jpeg;base64, ' + arrayFotos.imagem"
          :title="arrayFotos.tempo"
          alt="Falha ao carregar imagem"
        />

        <span>{{ arrayFotos.tempo.split(' ')[1] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import BadgeCircle from 'core/BadgeCircle'
import Button from 'core/Button'

export default {
  name: 'FotosMonitoramento',
  components: {
    Button,
    BadgeCircle,
  },
  props: {
    tab: String,
    entidade: Object,
    showing: Array | Object,
    loading: Boolean,
  },
  methods: {
    modalPhotos(entidade) {
      this.$emit('modalPhotos', entidade)
    },
    modalReport(entidade, type) {
      this.$emit('modalReport', this.showing, entidade, type)
    },
    checkAluno(entidade, anomalia) {
      this.$emit('checkAluno', entidade, anomalia)
    },
  },
}
</script>

<style lang="scss" scoped>
.bg {
  background-color: #e8eeff;
}

.foto-container {
  padding: 2rem;
  border-radius: 32px;

  display: flex;
  gap: 3rem;

  .perfil {
    flex: 1;
    max-width: 12.5rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .img-container {
      width: 12.5rem;
      position: relative;
      overflow: hidden;
      border-radius: 0.5rem;

      .card-img-top {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .nome-overlay {
        text-align: center;
        padding: 0.25rem;
        position: absolute;
        bottom: 0;
        width: 100%;
        min-height: 2.5rem;
        background-color: rgba(22, 22, 22, 0.7);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 0.75rem;
      }
    }

    .actions {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      button {
        justify-content: center;
      }

      .presenca {
        align-self: center;
        display: flex;
        align-items: center;
        gap: 0.5rem;

        span {
          font-weight: 600;
          font-size: 0.625rem;
          line-height: 100%;
          color: #202224;
        }
      }
    }
  }

  .photos {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;

    .photo {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      img {
        width: 10rem;
        border-radius: 10px;
      }

      span {
        align-self: center;
        font-weight: 400;
        font-size: 0.875rem;
      }
    }
  }
}
</style>
